module.exports = __webpack_public_path__ + "static/img/logo.d5057df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = Vpqn
// module chunks = 1